import React, { Component } from "react";
import { Styled } from "../../../toolkit/decorators/Artifact";
import ExternoDetalle from "../../../types/ExternoDetalle";
import permissionCodes from "../../../utils/permissionCodes";
import { userHasPermission } from "../../../utils/accessTree";
import s from "./styles.scss";
import { formatEnum } from "../../helpers/formatters";

const {
  MENU_INVITADO,
  MENU_MEMBRESIA_SOCIO,
  MENU_TOTAL_PASS
} = permissionCodes;

interface Props {
  detalle: ExternoDetalle;
}
interface State {}

@Styled(s)
export default class ExternoDetalleInfo extends Component<Props, State> {
  render() {
    const persona = this.props.detalle;
    const membresiaLabel = `${persona.idPublico} de ${persona.clubBase}`;
    const invitadoLabel = formatEnum(persona.tipoInvitado);

    return (
      <div className={`row ${s.details}`}>
        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Membresía</h5>
            {persona.idMembresiaSocio ? (
              userHasPermission(MENU_MEMBRESIA_SOCIO) ? (
                <a
                  href={`/membresias-socios/${persona.idMembresiaSocio}?idClub=${persona.idClubBase}&idPublico=${persona.idPublico}`}
                  target="_blank"
                >
                  {membresiaLabel}
                </a>
              ) : (
                membresiaLabel
              )
            ) : (
              "No"
            )}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Invitado</h5>
            {persona.idInvitado ? (
              userHasPermission(MENU_INVITADO) ? (
                <a
                  href={`/invitado-especial/${persona.idInvitado}`}
                  target="_blank"
                >
                  {invitadoLabel}
                </a>
              ) : (
                invitadoLabel
              )
            ) : (
              "No"
            )}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>TotalPass</h5>
            {persona.totalPass ? (
              userHasPermission(MENU_TOTAL_PASS) ? (
                <a
                  href={`/total-pass-detalle/${persona.idPersona}`}
                  target="_blank"
                >
                  Sí (Ver)
                </a>
              ) : (
                "Sí"
              )
            ) : (
              "No"
            )}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Empleado</h5>
            {persona.idAuthUser ? persona.numeroEmpleado : "No"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>CURP</h5>
            {persona.curp || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Tipo</h5>
            {formatEnum(persona.tipo) || "-"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Blacklist</h5>
            {persona.vetado ? "Sí" : "No"}
          </div>
        </div>

        <div className="col-md-3 col-sm-6 mb-3">
          <div className={s.dataItem}>
            <h5>Eliminada</h5>
            {persona.eliminado ? "Sí" : "No"}
          </div>
        </div>
      </div>
    );
  }
}
